import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { userNotificationsSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

export const params = {
  queryKey: [API_ENDPOINTS.NOTIFICATIONS],
  queryFn: () => get(API_ENDPOINTS.NOTIFICATIONS, userNotificationsSchema),
}

export const useAPIGetUserNotifications = () => useQuery(params)

export const useAPIGetUserNotificationsSuspense = () => useSuspenseQuery(params)
